import { useContext } from 'react'
import NavBar from './navbar'
import {
  Background,
  MenuIcon,
  NavBarWrapperContainer,
  NavBarWrapperFlexbox,
  UserName
} from './navbar-styles'
import closeIcon from './assets/close-window.png'
import UserImage from '../header/user-image'
import { LoginContext } from '../../contexts/login-context'
import { MenuContext } from '../../contexts/menu-context'

type NavBarWrapperProps = {
  signOutHandler: () => void
}

const MobileMenuPanel = ({ signOutHandler }: NavBarWrapperProps) => {
  const { user } = useContext(LoginContext)
  const { menuOpen, setMenuOpen } = useContext(MenuContext)

  return (
    <>
      <Background onClick={() => setMenuOpen(false)} className={menuOpen ? 'show' : ''} />
      <NavBarWrapperContainer className={menuOpen ? 'show' : ''}>
        <NavBarWrapperFlexbox>
          <UserImage />
          <MenuIcon src={closeIcon} onClick={() => setMenuOpen(false)} />
        </NavBarWrapperFlexbox>
        <UserName>{user?.displayName}</UserName>
        <NavBar signOutHandler={signOutHandler} />
      </NavBarWrapperContainer>
    </>
  )
}

export default MobileMenuPanel
